goog.provide('el8.app.shared.dialog.dataExchange');

goog.require('el8.appchart.dialog.tesst');
goog.require('el8.appchart.dialog.customCcda');
goog.require('el8.appchart.dialog.referralCcda');
goog.require('el8.uiwidget.QuickSelectDialog');
goog.require('el8.util.amplitude.immunizationHelpers');
goog.require('el8.util.amplitude.dataExchangeHelpers');

el8.app.shared.dialog.dataExchange = (function() {

    var _Options = [];

    if (el8Globals.APP === 'chart') {

        _Options.push(
            {
                callbackFn: function () { el8React.dispatch.openSinglePatientExportDialog(); },
            name: 'Export Entire Health Information (EHI)',
            // it's a function because we don't have this info on initialize
                disabledFn: function () { return !el8.data.currUser.isPracticeAdmin(); }
            },
            {
                url: el8Globals.PATIENT_PATH + 'ccda/export/',
                name: 'Export Complete Record (C-CDA)',
                // it's a function because we don't have this info on initialize
                disabledFn: function() { return !el8.data.currUser.isPracticeAdmin(); }
            },
            {
                callbackFn: function() { el8.appchart.dialog.customCcda.show(); },
                name: 'Export Customized Record (C-CDA)',
                // it's a function because we don't have this info on initialize
                disabledFn: function() { return !el8.data.currUser.isPracticeAdmin(); }
            },
            {
                callbackFn: function() { el8.appchart.dialog.referralCcda.show(); },
                name: 'Export Referral Record (C-CDA)',
                // it's a function because we don't have this info on initialize
                disabledFn: function() { return !el8.data.currUser.isPracticeAdmin(); }
            },
            {
                url: el8Globals.PATIENT_PATH + 'ccda/export/?blue_button_function=generateProgressNote',
                name: 'Export Progress Notes (C-CDA)',
                // it's a function because we don't have this info on initialize
                disabledFn: function() { return !el8.data.currUser.isPracticeAdmin(); }
            },
            {
                url: el8Globals.PATIENT_PATH + 'ccda/export/?blue_button_function=generateCarePlan',
                name: 'Export Care Plan (C-CDA)',
                // it's a function because we don't have this info on initialize
                disabledFn: function() { return !el8.data.currUser.isPracticeAdmin(); }
            },
            {
                url: el8Globals.PATIENT_PATH + 'reports/cqm/qrda1/',
                name: 'Export QRDA1',
                disabledFn: function() { return !el8.data.currUser.isPracticeAdmin(); }
            },
            {
                url: el8Globals.PATIENT_PATH + 'publichealth/',
                name: 'Public Health Sharing',
            },
            // {
            //     url: el8Globals.PATIENT_PATH + 'syndromic_data/export/',
            //     name: 'Export Syndromic Surveillance Information'
            // },
            // {
            //     callbackFn: function() { el8.appchart.dialog.tesst.show(); },
            //     name: 'Export Customized Record (Syndromic Surveillance)'
            // },
            {
                url: el8Globals.PATIENT_PATH + 'audit_log/',
                name: 'Audit Logs'
            }
        );

        if (el8Globals.FEATURES.ImmunizationHl7) {
            _Options.push({
                url: el8Globals.PATIENT_PATH + 'immunization/query/',
                name: 'Export Immunization HL7 Query'
            })
        }
    }

    var that = new el8.uiwidget.QuickSelectDialog({
        title: 'Data Exchange Functions',
        list: _Options,
        footerMsg: 'For more information about these options, please visit the <a href="//help.elationhealth.com/s/article/Supported-Elation-CCDA-types" target="_blank" rel="noopener noreferrer">Help Center article</a>.',
        callbackFn: function(index) {
            el8.util.amplitude.logViewDataExchangeFunction(_Options[index].name);
            if (_Options[index].url) {
                var url = _Options[index].url;
                window.open(url);
                if (_Options[index].name === "Public Health Sharing") {
                    el8.util.amplitude.logNavigateToPublicHealthDataExchangePage();
                }
            } else if (_Options[index].callbackFn) {
                _Options[index].callbackFn();
            }
            that.hide();

        },
        getTextFn: function(obj) {
            return obj['name'];
        },
        /**
         * The goal of the post show is to disable the export CCDA buttons if the user
         * is not an admin.
         */
        postShowFn: function() {
            var that = this;
            var disabledIdxs = [];
            that._list.forEach(function(item, idx) {
                if (item.disabledFn && item.disabledFn()) {
                    $('.select-option[_index="'+idx+'"]', that.getContentElt()).prop('disabled', true);
                    disabledIdxs.push(idx);
                }
            });
            // focus on the first active button
            // NOTE: there's an assumption that at least one item is active
            var activeIdxs = Array.from(Array(that._list.length).keys()).filter(function(index) {
                return !disabledIdxs.includes(index);
            });
            that.focusButton(activeIdxs[0]);
        }
    });

    return that;

})();

